import React, { useState } from "react";
import {
  TouchableOpacity,
  View,
  TouchableWithoutFeedback,
  StyleSheet,
  Platform,
  TouchableNativeFeedback,
  Switch,
  TextInput,
} from "react-native";
import { useSelector, useDispatch } from "react-redux";
import Colors from "../constants/Colors";
import DefaultText from "./text/DefaultText";
import DefaultTextBold from "./text/DefaultTextBold";
import { Ionicons, Feather } from "@expo/vector-icons";
import Slider from "@react-native-community/slider";
import { useNavigation } from "@react-navigation/native";
import * as deviceActions from "../store/actions/device";

const DeviceCard = (props) => {
  const socket = useSelector((state) => state.socket.io);
  const myDevices = useSelector((state) => state.devices.myDevices);
  const selectedDevice = myDevices.find(
    (device) => device.deviceId == props.deviceId
  );
  const isPlay = selectedDevice.settings.mode === "play";
  const dispatch = useDispatch();
  const navigation = useNavigation();

  let TouchableCmp = TouchableOpacity;

  if (Platform.OS === "android" && Platform.Version >= 21) {
    TouchableCmp = TouchableNativeFeedback;
  }
  const [isPowerOn, setIsPowerOn] = useState(true);
  const [editName, setEditName] = useState(false);
  const [name, setName] = useState(props.name);

  const [isMuted, setIsMuted] = useState(false);
  const [isAutoBright, setIsAutoBright] = useState(false);
  const toggleEditName = () => {
    setEditName((previousState) => !previousState);
    setName(props.name);
  };
  const editNameHandler = (enteredName) => {
    console.log("here");
    setName(enteredName);
  };
  const updateDeviceName = () => {
    dispatch(deviceActions.updateDeviceName(props.deviceId, name, socket));
    setEditName(false);
  };
  const togglePowerSwitch = () => {
    setIsPowerOn((previousState) => !previousState);
    const nextPower = !isPowerOn;
    console.log("power:", !isPowerOn);
    dispatch(
      deviceActions.updateDeviceSetting(
        props.deviceId,
        "power",
        nextPower ? "on" : "off",
        socket
      )
    );
  };
  const togglePlaySwitch = (isPlay) => {
    const nextPlay = !isPlay;
    console.log("Play mode:", nextPlay);
    dispatch(
      deviceActions.updateDeviceSetting(
        props.deviceId,
        "mode",
        nextPlay ? "play" : "pause",
        socket
      )
    );
  };
  const toggleMutedSwitch = () => setIsMuted((previousState) => !previousState);
  const toggleAutoBrightSwitch = () =>
    setIsAutoBright((previousState) => !previousState);
  const volumeHandler = (value) => {
    console.log("volume:", value);
    dispatch(
      deviceActions.updateDeviceSetting(props.deviceId, "volume", value, socket)
    );
  };

  const jumpHandler = () => {
    navigation.navigate("DeviceDetailScreen", {
      deviceId: props.deviceId,
      togglePlaySwitch: togglePlaySwitch,
    });
  };
  return (
    <View style={styles.card}>
      <View style={styles.topContainer}>
        {editName ? (
          <TextInput
            placeholderTextColor="white"
            onChangeText={(text) => {
              editNameHandler(text);
            }}
            value={name}
            style={styles.inputContainer}
            onSubmitEditing={updateDeviceName}
            returnKeyType="done"
            autoFocus
            onBlur={toggleEditName}
            // blurOnSubmit={true}
          />
        ) : (
          <TouchableCmp onPress={toggleEditName} style={styles.deviceName}>
            <DefaultTextBold>{props.name}</DefaultTextBold>

            <Feather style={styles.edit} name="edit" size={16} color="white" />
          </TouchableCmp>
        )}
        <TouchableCmp style={styles.touchable} onPress={jumpHandler}>
          <DefaultText style={{ color: Colors.accent }}>
            View Playlist
          </DefaultText>
        </TouchableCmp>
      </View>
      <View style={styles.midContainer}>
        <View style={styles.powerContainer}>
          <DefaultText>Power</DefaultText>
          <Switch
            trackColor={{ false: "#767577", true: Colors.accent }}
            thumbColor={isPowerOn ? Colors.primary : "#f4f3f4"}
            ios_backgroundColor="#3e3e3e"
            onValueChange={togglePowerSwitch}
            value={isPowerOn}
            style={{
              transform: [{ scaleX: 0.7 }, { scaleY: 0.7 }, { translateX: 15 }],
            }}
          />
        </View>
        <View style={styles.hline} />
        <View style={styles.powerContainer}>
          <DefaultText>Mode</DefaultText>

          <TouchableCmp
            onPress={() => {
              togglePlaySwitch(isPlay);
            }}
          >
            <Ionicons
              // name={isPlay ? "pause" : "play"}
              name={"play"}
              size={26}
              color="white"
            />
          </TouchableCmp>
        </View>
        <View style={styles.hline} />
        <View style={styles.powerContainer}>
          <DefaultText>Volume</DefaultText>
          {/* 
          <TouchableCmp onPress={props.onSelect}>
            <Ionicons name="chevron-down-outline" size={26} color="white" />
          </TouchableCmp> */}
          <Slider
            style={{
              width: "80%",
              transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }, { translateX: 30 }],
            }}
            value={0.5}
            minimumValue={0}
            maximumValue={1}
            minimumTrackTintColor={Colors.accent}
            maximumTrackTintColor="#FFFFFF"
            onSlidingComplete={(value) => {
              console.log("Volume1", value);
              volumeHandler(value);
            }}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flexDirection: "row",
  },

  remove: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 70,
  },
  card: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 40,
  },
  topContainer: {
    width: "85%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  deviceName: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  edit: {
    paddingHorizontal: 10,
  },
  midContainer: {
    flex: 1,
    width: "90%",
    alignItems: "center",
    justifyContent: "space-evenly",
    borderColor: "white",
    borderWidth: 1,
  },
  powerContainer: {
    width: "85%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginVertical: 16,
  },
  hline: {
    borderBottomColor: Colors.primary,
    borderBottomWidth: 1,
    width: "90%",
  },
  inputContainer: {
    color: "white",
    fontFamily: "JosefinSans_700Bold",
    borderColor: "white",
  },
});

export default DeviceCard;
